webpackJsonp([213534597649335],{

/***/ 410:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cardBody":"src-pageComponents-home-components-aboutCard----aboutCard-module---cardBody---1Mp2y","sectionHeader":"src-pageComponents-home-components-aboutCard----aboutCard-module---sectionHeader---3g4Tv","sectionContent":"src-pageComponents-home-components-aboutCard----aboutCard-module---sectionContent---4K8tC"};

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cardModule = __webpack_require__(60);
	
	var _cardModule2 = _interopRequireDefault(_cardModule);
	
	var _aboutCardModule = __webpack_require__(410);
	
	var _aboutCardModule2 = _interopRequireDefault(_aboutCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-line import/no-extraneous-dependencies
	var AboutCard = function AboutCard() {
	    return _react2.default.createElement(
	        'div',
	        { className: '' + _cardModule2.default.card },
	        _react2.default.createElement(
	            'div',
	            { className: _aboutCardModule2.default.cardBody + ' ' + _cardModule2.default.cardBody },
	            _react2.default.createElement(
	                'div',
	                { className: '' + _aboutCardModule2.default.sectionHeader },
	                'So who are we?'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: '' + _aboutCardModule2.default.sectionContent },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Now that we\'ve established that we are twins, lets move on to what makes us... well... us! For one thing, we\'ve been in the same schools, the same colleges and now we\'re working in the same place! We also wear matching clothes everyday! (yup, we really embrace our twin-ness!).'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'We\'re software engineers, web developers, gamers, hobbyist game developers, VR enthusiasts, and we dabble a bit in sketching, writing and poetry but before all that, ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'we\'re brothers.'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'We have a lot of similar interests, including, (as you might have guessed) Virtual Reality.(VR capable website: coming soon!). While you\'re here, be sure to scroll down and read a little more about each of us, check out some of the stuff we\'ve been working on, and browse through some of our thoughts and ideas that span a variety of topics.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Don\'t leave without saying hello!  You can find either one of us on Facebook!'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Or on LinkedIn if you want to be all formal.'
	                )
	            )
	        )
	    );
	};
	
	exports.default = AboutCard;
	module.exports = exports['default'];

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cardModule = __webpack_require__(60);
	
	var _cardModule2 = _interopRequireDefault(_cardModule);
	
	var _mainCardModule = __webpack_require__(411);
	
	var _mainCardModule2 = _interopRequireDefault(_mainCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-line import/no-extraneous-dependencies
	var MainCard = function MainCard() {
	  return _react2.default.createElement(
	    'div',
	    { className: _cardModule2.default.card },
	    _react2.default.createElement(
	      'div',
	      { className: _mainCardModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _mainCardModule2.default.mainBanner + ' ' + _mainCardModule2.default.banner },
	        _react2.default.createElement(
	          'div',
	          { className: _mainCardModule2.default.bannerSubtitle + ' ' + _mainCardModule2.default.alignStart },
	          _react2.default.createElement(
	            'span',
	            null,
	            'In case you were wondering...'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _mainCardModule2.default.bannerTitle + ' ' + _mainCardModule2.default.alignCenter },
	          _react2.default.createElement(
	            'span',
	            null,
	            'Yes, we are Twins'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _mainCardModule2.default.bannerSubtitle + ' ' + _mainCardModule2.default.alignEnd },
	          _react2.default.createElement('span', null)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _mainCardModule2.default.descContainer },
	      _react2.default.createElement(
	        'div',
	        { className: '' + _mainCardModule2.default.aboutUs },
	        _react2.default.createElement(
	          'p',
	          { className: _mainCardModule2.default.sectionHeader },
	          'And yes, we do get asked that a lot!'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _mainCardModule2.default.sectionParagraph },
	          'Welcome to the personal lair of the Rajendran twins!'
	        )
	      )
	    )
	  );
	};
	
	exports.default = MainCard;
	module.exports = exports['default'];

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"banner":"src-pageComponents-home-components-mainCard----mainCard-module---banner---1ARZ6","bannerTitle":"src-pageComponents-home-components-mainCard----mainCard-module---bannerTitle---A7y-w","bannerSubtitle":"src-pageComponents-home-components-mainCard----mainCard-module---bannerSubtitle---La5i3","mainBanner":"src-pageComponents-home-components-mainCard----mainCard-module---mainBanner---3Txmh","container":"src-pageComponents-home-components-mainCard----mainCard-module---container---2GLgt","descContainer":"src-pageComponents-home-components-mainCard----mainCard-module---descContainer---1VSJ_","sectionHeader":"src-pageComponents-home-components-mainCard----mainCard-module---sectionHeader---3UckW","sectionParagraph":"src-pageComponents-home-components-mainCard----mainCard-module---sectionParagraph---2-6JL","alignStart":"src-pageComponents-home-components-mainCard----mainCard-module---alignStart---2M3pG","alignCenter":"src-pageComponents-home-components-mainCard----mainCard-module---alignCenter---1-9VU","alignEnd":"src-pageComponents-home-components-mainCard----mainCard-module---alignEnd---3y4Uf"};

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cardModule = __webpack_require__(60);
	
	var _cardModule2 = _interopRequireDefault(_cardModule);
	
	var _mainCard = __webpack_require__(357);
	
	var _mainCard2 = _interopRequireDefault(_mainCard);
	
	var _aboutCard = __webpack_require__(356);
	
	var _aboutCard2 = _interopRequireDefault(_aboutCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home() {
	  return [_react2.default.createElement(
	    'div',
	    { key: 'firstCard', className: _cardModule2.default.halfCardContainer + ' ' + _cardModule2.default.firstCard },
	    _react2.default.createElement(_mainCard2.default, null)
	  ), _react2.default.createElement(
	    'div',
	    { key: 'secondCard', className: _cardModule2.default.halfCardContainer },
	    _react2.default.createElement(_aboutCard2.default, null)
	  )];
	}; // eslint-disable-line import/no-extraneous-dependencies
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(200);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _home = __webpack_require__(358);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return [_react2.default.createElement(_reactHelmet2.default, { key: 'homeHelmet', title: 'YesWeAreTwins' }), _react2.default.createElement(_home2.default, { key: 'homePage' })];
	};
	/* eslint-enable import/no-extraneous-dependencies */
	
	/* eslint-disable import/no-extraneous-dependencies */
	

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-8491c86d61e3d63eeb95.js